import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// UX4G assets (local files under project assets/). Importing CSS here lets webpack bundle it.
// If the ESM build is available, import it so webpack can bundle it. Otherwise you can load the UMD from public.
import App from './App';
import './i18n';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, theme } from 'antd';
import { initializeVillageTheme } from './utils/themeManager';

// Apply village-specific theme colors based on domain
initializeVillageTheme();

const { defaultAlgorithm } = theme;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider
        theme={{
          algorithm: defaultAlgorithm,
         "token": {
    "colorPrimary": "var(--color-primary)",
    "colorInfo": "var(--color-primary)",
    "colorSuccess": "var(--color-primary)",
   
    
  },

        }}
      >
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
);
